import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FeatureOptionTokenService} from '@catmodules/models/feature-option-tokens/services/feature-option-token.service';
import {NetworkInterfacesModule} from '@catmodules/models/network-interfaces/network-interfaces.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import { FeatureOptionTokenFormComponent } from './components/feature-option-token-form/feature-option-token-form.component';

const publicComponents = [
  FeatureOptionTokenFormComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  NetworkInterfacesModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureOptionTokenService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureOptionTokenModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-option-tokens/feature-option-token.module.ts